import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12, delayChildren: 0.25 } },
};
const lineMask = {
  hidden: { y: "110%" },
  show: { y: "0%", transition: { duration: 1.1, ease: EASE } },
};
const fadeUp = {
  hidden: { opacity: 0, y: 16 },
  show: { opacity: 1, y: 0, transition: { duration: 0.9, ease: EASE } },
};

export function Hero({ t, onTalk }) {
  return (
    <motion.section
      data-testid="hero"
      variants={container}
      initial="hidden"
      animate="show"
      className="min-h-screen flex flex-col justify-center px-6 md:px-12 lg:px-24"
    >
      <div className="max-w-[1400px] w-full">
        <h1 className="font-display font-extrabold uppercase tracking-[-0.03em] text-[clamp(2.75rem,9vw,8.5rem)]">
          <span className="block overflow-hidden">
            <motion.span variants={lineMask} className="block leading-[1.15]">
              {t.hero.l1}
            </motion.span>
          </span>
          <span className="block overflow-hidden -mt-[0.16em]">
            <motion.span variants={lineMask} className="block leading-[1.15]">
              {t.hero.l2}
            </motion.span>
          </span>
        </h1>

        <div className="mt-8 md:mt-12 flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <div>
            <motion.p variants={fadeUp} className="text-lg md:text-2xl tracking-tight text-bh-ink">
              {t.hero.support}
            </motion.p>

            <motion.div variants={fadeUp} className="mt-9">
              <button
                data-testid="talk-to-us-btn"
                onClick={onTalk}
                className="group inline-flex items-center gap-3 text-base md:text-lg"
              >
                <span className="relative">
                  {t.hero.cta}
                  <span className="absolute left-0 -bottom-1 h-px w-full bg-bh-ink origin-left scale-x-100 group-hover:scale-x-0 transition-transform duration-500" />
                  <span className="absolute left-0 -bottom-1 h-px w-full bg-bh-ink origin-right scale-x-0 group-hover:scale-x-100 transition-transform duration-500 delay-100" />
                </span>
                <span className="transition-transform duration-500 group-hover:translate-x-2">→</span>
              </button>
            </motion.div>
          </div>

          <motion.p
            variants={fadeUp}
            className="max-w-xs text-sm md:text-base leading-relaxed text-bh-soft md:text-right"
          >
            {t.hero.para}
          </motion.p>
        </div>
      </div>
    </motion.section>
  );
}
